import { IMAGE_WIDTH_PX, IMAGE_HEIGHT_PX } from '../components/utils/parser';

export const ITEM_MARGIN = 10;

export const getImageExtensionListStyles = () => ({
  listContainer: ({ cellWidth, cellHeight }) => ({
    '& .ms-List-cell': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: cellWidth,
      height: cellHeight,
    },
    '& .ms-List-page': {
      display: 'inline-flex',
      flexWrap: 'wrap',
      gap: '10px',
      paddingBottom: '10px',
    },
  }),
});

export const getImageExtensionItemStyles = (components, { palette }) => {
  const itemZIndex = 1;
  const styles = {
    itemContainer: {
      position: 'relative',
      '&.hovered:not(.disabled), &.selected': {
        '& $selectRadio': {
          display: 'block',
        },
      },

      '&.hovered .image-extension-item': {
        cursor: 'pointer',
      },

      '&.disabled .image-extension-item': {
        pointerEvents: 'none',
        opacity: 0.4,
      },

      // there is a gap because of fractional width in chrome between parent and image.
      // so use pseudo class to draw the border
      '&.hovered .image-extension-item:after, &.selected .image-extension-item:after': {
        content: '""',
        borderStyle: 'solid',
        borderWidth: 2,
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        borderColor: palette.themePrimary,
        borderRadius: '5%',
      },

    },
    imageExtensionItem: {
      position: 'relative',
      zIndex: itemZIndex,
      width: IMAGE_WIDTH_PX,
      height: IMAGE_HEIGHT_PX,
    },

    btnItem: {
      color: palette.themePrimary,
      backgroundColor: palette.white,
      border: 'none',
    },
    textItem: {
      textDecoration: 'underline',
    },

    selectRadio: {
      position: 'absolute',
      top: 4,
      left: 100,
      zIndex: 1,
      display: 'none',

      '& :checked': {
        display: 'block',
      },
    },
    imageContainer: {
      borderRadius: '5%',
      boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    },
    deleteButton: {
      fontSize: 16,
      padding: 8,
      position: 'absolute',
      left: 86,
      top: 36,

      '&.circular-hover': {
        backgroundColor: `${palette.white}d4`,
        borderRadius: '50%',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: itemZIndex + 1, // need to greater so that it can be clicked
      },

      '&.circular-hover:hover': {
        backgroundColor: `${palette.themeDarkAlt}ff`,
        cursor: 'pointer',

        '&:before': {
          color: palette.white,
        },
      },
    },
    editButton: {
      fontSize: 16,
      padding: 8,
      position: 'absolute',
      left: 8,
      top: 36,

      '&.circular-hover': {
        backgroundColor: `${palette.white}d4`,
        borderRadius: '50%',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: itemZIndex + 1,
      },

      '&.circular-hover:hover': {
        backgroundColor: `${palette.themeDarkAlt}ff`,
        cursor: 'pointer',

        '&:before': {
          color: palette.white,
        },
      },
    },
    noImageFallbackContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyItems: 'center',
      alignItems: 'center',
      backgroundColor: palette.neutralLighter,

      '& svg': {
        width: 32,
        height: 32,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
  };

  return styles;
};
